// extracted by mini-css-extract-plugin
export default {"container":"style_container__dMbn3","card":"style_card__z5PZC","row":"style_row__y3gvf","btnsRow":"style_btnsRow__JaZZK"};